



















import {Component, Vue, Watch} from 'vue-property-decorator';
import {Call, Sync} from 'vuex-pathify';
import NavigationDrawer from '@/components/Views/UI/NavigationDrawer.vue';
import servicesPages from './routing/services';
import locationsPages from './routing/locations';
import NavDropdown from '@/components/Views/UI/NavDropdown.vue';
import GlobalAlert from '@/components/Views/UI/GlobalAlert.vue';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {multiNil, nil, getPreRenderedRoutes} from '@/common';
import SiteNavbar from '@/components/Views/UI/SiteNavbar.vue';
import BookingNavbar from '@/components/Views/UI/BookingNavbar.vue';
import ToolbarMixin from '@/mixins/ToolbarMixin.vue';
import routes from '@/routing/routes';


@Component({
    components: {BookingNavbar, SiteNavbar, GlobalAlert, NavDropdown, NavigationDrawer},
})
export default class App extends Mixins(UserRoleMixin, ToolbarMixin) {
    get dropdownServices() {
        return servicesPages.filter((x) => x.path !== '');
    }

    get dropdownLocations() {
        return locationsPages.filter((x) => x.path !== '');
    }
    get touchUpAd() {
        return 'Get a Complimentary Touch-Up Kit with Every SoPlush Beauty Pro Booking!';
    }
    public toolbarOffset = 0;
    public getToolbarOffset() {
        const sysbar = document.querySelector('#sysbar');
        if (!nil(sysbar)) {
            return sysbar.clientHeight;
        }
        return 0;
    }
    get isLocal() {
        return document.location.hostname === 'localhost';
    }
    get topAdVisible() {
        return this.showTopAd && this.toolbarMode === 0;
    }
    get offsetFromAd() {
        return this.showTopAd ? this.toolbarOffset : 0;
    }
    @Watch('topAdVisible', {immediate: true})
    public onTopAdVisibleChanged(value: boolean, oldValue: boolean) {
        if (value) {
            setTimeout(() => {
                this.toolbarOffset = this.getToolbarOffset();
            }, 250);
        }
    }
    public get mobileToolbar() {
        return !this.isLG(true);
    }
    @Sync('ui/toolbarMode') private toolbarMode!: number;

    public navigationItems = [
        {type: 'dropdown', text: 'Services', children: this.dropdownServices, link: '/services', hideOnMini: true},
        {type: 'link', text: 'Weddings', link: '/services/weddings', icon: 'fas fa-heart'},
        {type: 'link', text: 'Special Events', link: '/services/events', icon: 'fas fa-glass-cheers'},
        {type: 'link', text: 'Packages', link: '/packages', icon: 'fas fa-dollar-sign'},
        {type: 'link', text: 'Gift Cards', link: '/gift-cards', icon: 'fas fa-gift'},
        /* {type: 'dropdown', text: 'Cities', children: this.dropdownLocations, link: '/locations'},*/
        {type: 'link', text: 'FAQ\'s', link: '/faqs', icon: 'fas fa-question'},
        {type: 'link', text: 'About', link: '/about', icon: 'fas fa-book'},
    ];

    private drawerOpen = null;
    private showTopAd = true;
    private versionNumber = '';


    @Watch('user')
    public onUserChanged(value: any, oldValue: any) {
        this.checkTopAd();
    }
    public mounted() {
        // this.printPreRenderedRoutes();
        this.versionNumber = process.env.VERSION;
        this.checkTopAd();
        if (!this.userIsAdmin && !this.isLocal) {
            setTimeout(() => {
                (window as any).initTawk();
            }, 1000);
        }
    }
    private printPreRenderedRoutes() {
        console.log(getPreRenderedRoutes(routes(this.$store)));
    }
    public checkTopAd() {
        this.showTopAd = this.userIsCustomer;
    }

    public logout() {
        this.$store.dispatch('auth/logout');
        this.$router.replace('/');
    }



    public get sizeText() {
        if (this.isXL(null)) {
            return 'XL';
        } else if (this.isLG(null)) {
            return 'LG';
        } else if (this.isMD(null)) {
            return 'MD';
        } else if (this.isSM(null)) {
            return 'SM';
        } else if (this.isXS(null)) {
            return 'XS';
        }
    }
    public get touchUpAdSize() {
        let modifier = 1;
        if (this.isXL(null)) {
            modifier = 1.3;
        } else if (this.isLG(null)) {
            modifier = 1;
        } else if (this.isMD(null)) {
            modifier = 0.7;
        } else if (this.isSM(null)) {
            modifier = 0.6;
        } else if (this.isXS(null)) {
            modifier = 0.5;
        }
        return `font-size:${1.4 * modifier}rem`;

    }
    public get appAdvertisementClass() {
        return {
            hasAdvertisement: (this.toolbarMode === 0 && (this.userIsNull || this.userIsCustomer)),
        };
    }
}
